import { useEffect } from 'react';
import I18n from 'I18n';
import FieldGroup from 'ContentComponents/components/cmv2/fields/FieldGroup';
import { jsx as _jsx } from "react/jsx-runtime";
const FormAutomationFieldGroup = ({
  stretchToSides,
  fieldGroupOpen,
  onFieldGroupOpenChange,
  children,
  willScrollAfterRemount,
  resetWillScrollAfterRemount
}) => {
  useEffect(() => {
    if (willScrollAfterRemount) {
      document.dispatchEvent(new CustomEvent('FIELD_REVEAL_LISTENER_READY'));
      resetWillScrollAfterRemount();
    }
  });
  return /*#__PURE__*/_jsx(FieldGroup, {
    fieldKey: ['form-expandable-section-automation'],
    label: I18n.text('ContentComponents.cmv2.fields.form.withInlineEditing.automation.label'),
    stretchToSides: stretchToSides,
    withContentPadding: true,
    containsNestedGroups: false,
    fieldGroupOpen: fieldGroupOpen,
    onFieldGroupOpenChange: onFieldGroupOpenChange,
    onFieldReset: () => {},
    children: children
  });
};
export default FormAutomationFieldGroup;